<div class="flex flex-col h-full">

  <div class="flex-auto overflow-auto relative">
    <table mat-table [dataSource]="dataSource" matSort class="w-full">

      <ng-container matColumnDef="material">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-material">
          <span class="f-10">Material</span>
        </th>
        <td mat-cell *matCellDef="let element" class="sticky-column">
          <span class="font-medium flex flex-col truncate line-clamp-2">
            <span class="f-10">{{ element.materialName || '-' }}</span>
            <span class="text-xs text-gray-500 f-9" *ngIf="element.materialCode">
              {{ element.materialCode }}
            </span>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="materialGroup">
        <th class="!min-w-[170px]" mat-header-cell *matHeaderCellDef mat-sort-header>
          <span class="f-10">Grupo Material</span>
        </th>
        <td mat-cell *matCellDef="let element"
            [matTooltip]="element.materialGroupName || '-'">
          <span class="f-10">{{ element.materialGroupName || '-' }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="customer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-customer">
          <span class="f-10">Cliente</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="font-medium flex flex-col truncate line-clamp-2">
            <span class="f-10">{{ element.customerName || '-' }}</span>
            <span class="text-xs text-gray-500 f-9" *ngIf="element.customerCode">
              {{ element.customerCode }}
            </span>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="numberOrder">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="!min-w-[120px]">
          <span class="f-10">Pedido</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <app-document-navigation
            [documentType]="DocumentTypeEnum.PEDIDO"
            [documentSerial]="element.numberOrder"
            [customClass]="'f-10'"
            [showIcon]="true">
          </app-document-navigation>
        </td>
      </ng-container>

      <ng-container matColumnDef="invoiceDocument">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="!min-w-[120px]">
          <span class="f-10">Factura</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="f-10">{{ element.invoiceDocument || '-' }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="sellerToName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="!min-w-[180px]">
          <span class="f-10">Responsable</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="font-medium flex flex-col truncate line-clamp-2">
            <span class="f-10">{{ element.sellerToName || '-' }}</span>
            <span class="text-xs text-gray-500 f-9" *ngIf="element.sellerToCode">
              {{ element.sellerToCode }}
            </span>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="locationTwo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="!min-w-[150px]">
          <span class="f-10">Ubicación</span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="f-10">{{ element.locationTwo || '-' }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="ordersCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center column-orders">
          <span class="f-10"># Pedidos</span>
        </th>
        <td mat-cell *matCellDef="let element" class="text-center">
          <span class="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-semibold f-9">
            {{ element.ordersCount }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="totalSoldOriginalQuantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-quantity !min-w-[210px]">
          <span class="f-10">Cantidad Deseada</span>
        </th>
        <td mat-cell *matCellDef="let element" >
          <div class="text-content text-xs">
            <app-unit-measure-display
              [baseUnit]="{
                quantity: element.totalSoldOriginalQuantityUMB,
                unitId: element.unitOfMeasure?.base?.id,
                unitName: element.unitOfMeasure?.base?.name,
                unitAbbreviation: element.unitOfMeasure?.base?.code
              }"
              [parallelUnit]="{
                quantity: element.totalSoldOriginalQuantityUMP,
                unitId: element.unitOfMeasure?.parallel?.id,
                unitName: element.unitOfMeasure?.parallel?.name,
                unitAbbreviation: element.unitOfMeasure?.parallel?.code
              }"
              [material]="{
                _id: element.materialId,
                code: element.materialCode,
                UMPActive: !!element.unitOfMeasure?.parallel
              }"
              [companyUMPActive]="UMPActive"
            ></app-unit-measure-display>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="totalSoldQuantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-quantity !min-w-[210px]">
          <span class="f-10">Cantidad Vendida</span>
        </th>
        <td mat-cell *matCellDef="let element" >
          <div class="text-content text-xs">
            <app-unit-measure-display
              [baseUnit]="{
                quantity: element.totalSoldQuantityUMB,
                unitId: element.unitOfMeasure?.base?.id,
                unitName: element.unitOfMeasure?.base?.name,
                unitAbbreviation: element.unitOfMeasure?.base?.code
              }"
              [parallelUnit]="{
                quantity: element.totalSoldQuantityUMP,
                unitId: element.unitOfMeasure?.parallel?.id,
                unitName: element.unitOfMeasure?.parallel?.name,
                unitAbbreviation: element.unitOfMeasure?.parallel?.code
              }"
              [material]="{
                _id: element.materialId,
                code: element.materialCode,
                UMPActive: !!element.unitOfMeasure?.parallel
              }"
              [companyUMPActive]="UMPActive"
            ></app-unit-measure-display>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="totalConfirmedQuantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-quantity !min-w-[210px]">
          <span class="f-10">Cantidad Confirmada</span>
        </th>
        <td mat-cell *matCellDef="let element" >
          <div class="text-content text-xs">
            <app-unit-measure-display
              [baseUnit]="{
                quantity: element.totalConfirmedQuantityUMB,
                unitId: element.unitOfMeasure?.base?.id,
                unitName: element.unitOfMeasure?.base?.name,
                unitAbbreviation: element.unitOfMeasure?.base?.code
              }"
              [parallelUnit]="{
                quantity: element.totalConfirmedQuantityUMP,
                unitId: element.unitOfMeasure?.parallel?.id,
                unitName: element.unitOfMeasure?.parallel?.name,
                unitAbbreviation: element.unitOfMeasure?.parallel?.code
              }"
              [material]="{
                _id: element.materialId,
                code: element.materialCode,
                UMPActive: !!element.unitOfMeasure?.parallel
              }"
              [companyUMPActive]="UMPActive"
            ></app-unit-measure-display>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="totalDeliveredQuantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-quantity !min-w-[210px]">
          <span class="f-10">Cantidad Entregada</span>
        </th>
        <td mat-cell *matCellDef="let element" >
          <div class="text-content text-xs">
            <app-unit-measure-display
              [baseUnit]="{
                quantity: element.totalDeliveredQuantityUMB,
                unitId: element.unitOfMeasure?.base?.id,
                unitName: element.unitOfMeasure?.base?.name,
                unitAbbreviation: element.unitOfMeasure?.base?.code
              }"
              [parallelUnit]="{
                quantity: element.totalDeliveredQuantityUMP,
                unitId: element.unitOfMeasure?.parallel?.id,
                unitName: element.unitOfMeasure?.parallel?.name,
                unitAbbreviation: element.unitOfMeasure?.parallel?.code
              }"
              [material]="{
                _id: element.materialId,
                code: element.materialCode,
                UMPActive: !!element.unitOfMeasure?.parallel
              }"
              [companyUMPActive]="UMPActive"
            ></app-unit-measure-display>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="totalInvoicedQuantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-quantity !min-w-[210px]">
          <span class="f-10">Cantidad Facturada</span>
        </th>
        <td mat-cell *matCellDef="let element" >
          <div class="text-content text-xs">
            <app-unit-measure-display
              [baseUnit]="{
                quantity: element.totalInvoicedQuantityUMB,
                unitId: element.unitOfMeasure?.base?.id,
                unitName: element.unitOfMeasure?.base?.name,
                unitAbbreviation: element.unitOfMeasure?.base?.code
              }"
              [parallelUnit]="{
                quantity: element.totalInvoicedQuantityUMP,
                unitId: element.unitOfMeasure?.parallel?.id,
                unitName: element.unitOfMeasure?.parallel?.name,
                unitAbbreviation: element.unitOfMeasure?.parallel?.code
              }"
              [material]="{
                _id: element.materialId,
                code: element.materialCode,
                UMPActive: !!element.unitOfMeasure?.parallel
              }"
              [companyUMPActive]="UMPActive"
            ></app-unit-measure-display>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="sumSoldQuantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-currency !min-w-[210px]">
          <span class="f-10">Suma Pedido</span>
        </th>
        <td mat-cell *matCellDef="let element" >
          <span class="f-10">{{ formatCurrency(element.sumSoldQuantity, element.currency) }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="sumStockConfirmedERP">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-currency !min-w-[210px]">
          <span class="f-10">Suma Reserva</span>
        </th>
        <td mat-cell *matCellDef="let element" >
          <span class="f-10">{{ formatCurrency(element.sumStockConfirmedERP, element.currency) }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="sumDeliveredQuantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-currency !min-w-[210px]">
          <span class="f-10">Suma Desp</span>
        </th>
        <td mat-cell *matCellDef="let element" >
          <span class="f-10">{{ formatCurrency(element.sumDeliveredQuantity, element.currency) }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="sumInvoiceQuantity">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-currency !min-w-[210px]">
          <span class="f-10">Suma Factura</span>
        </th>
        <td mat-cell *matCellDef="let element" >
          <span class="f-10">{{ formatCurrency(element.sumInvoiceQuantity, element.currency) }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="lostSaleAmount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-currency !min-w-[210px]">
          <span class="f-10">Diferencia</span>
        </th>
        <td mat-cell *matCellDef="let element" >
          <span class="f-10" [ngClass]="getLostSaleClass(element.lostSaleAmount)">
            {{ formatCurrency(element.lostSaleAmount, element.currency) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="commercialLostSale">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-lost-sale !min-w-[210px] ">
          <span class="f-10">Comercial</span>
        </th>
        <td mat-cell *matCellDef="let element" >
          <div class="text-content">
            <span class="f-9">
              <b [ngClass]="getLostSaleClass(element.commercialLostSaleUMB)">UMB:</b>
              <span [ngClass]="getLostSaleClass(element.commercialLostSaleUMB)">{{ formatNumber(element.commercialLostSaleUMB) }} ({{element.unitOfMeasure?.base?.name || 'UMB'}})</span><br>
              <ng-container *ngIf="UMPActive">
                <b [ngClass]="getLostSaleClass(element.commercialLostSaleUMP)">UMP:</b>
                <span [ngClass]="getLostSaleClass(element.commercialLostSaleUMP)">{{ formatNumber(element.commercialLostSaleUMP) }} ({{element.unitOfMeasure?.parallel?.name || 'UMP'}})</span>
              </ng-container>
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="logisticLostSale">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-lost-sale !min-w-[210px]">
          <span class="f-10">Logística</span>
        </th>
        <td mat-cell *matCellDef="let element" >
          <div class="text-content">
            <span class="f-9">
              <b [ngClass]="getLostSaleClass(element.logisticLostSaleUMB)">UMB:</b>
              <span [ngClass]="getLostSaleClass(element.logisticLostSaleUMB)">{{ formatNumber(element.logisticLostSaleUMB) }} ({{element.unitOfMeasure?.base?.name || 'UMB'}})</span><br>
              <ng-container *ngIf="UMPActive">
                <b [ngClass]="getLostSaleClass(element.logisticLostSaleUMP)">UMP:</b>
                <span [ngClass]="getLostSaleClass(element.logisticLostSaleUMP)">{{ formatNumber(element.logisticLostSaleUMP) }} ({{element.unitOfMeasure?.parallel?.name || 'UMP'}})</span>
              </ng-container>
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="realLostSale">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="column-lost-sale !min-w-[210px]">
          <span class="f-10">Real</span>
        </th>
        <td mat-cell *matCellDef="let element" >
          <div class="text-content">
            <span class="f-9">
              <b [ngClass]="getLostSaleClass(element.realLostSaleUMB)">UMB:</b>
              <span [ngClass]="getLostSaleClass(element.realLostSaleUMB)">{{ formatNumber(element.realLostSaleUMB) }} ({{element.unitOfMeasure?.base?.name || 'UMB'}})</span><br>
              <ng-container *ngIf="UMPActive">
                <b [ngClass]="getLostSaleClass(element.realLostSaleUMP)">UMP:</b>
                <span [ngClass]="getLostSaleClass(element.realLostSaleUMP)">{{ formatNumber(element.realLostSaleUMP) }} ({{element.unitOfMeasure?.parallel?.name || 'UMP'}})</span>
              </ng-container>
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="commercialLostSalePercentage">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="!min-w-[210px]">
          <span class="f-10">% Comercial</span>
        </th>
        <td mat-cell *matCellDef="let element" >
          <span class="f-10" [ngClass]="getPercentageClass(element.commercialLostSalePercentage)">
            {{ formatPercentage(element.commercialLostSalePercentage) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="logisticLostSalePercentage">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="!min-w-[210px]">
          <span class="f-10">% Logística</span>
        </th>
        <td mat-cell *matCellDef="let element" >
          <span class="f-10" [ngClass]="getPercentageClass(element.logisticLostSalePercentage)">
            {{ formatPercentage(element.logisticLostSalePercentage) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="realLostSalePercentage">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="!min-w-[210px]">
          <span class="f-10">% Real</span>
        </th>
        <td mat-cell *matCellDef="let element" >
          <span class="f-10" [ngClass]="getPercentageClass(element.realLostSalePercentage)">
            {{ formatPercentage(element.realLostSalePercentage) }}
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
          class="hover:bg-gray-50 dark:hover:bg-gray-800"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center py-8" [attr.colspan]="displayedColumns.length">
          <div class="flex flex-col items-center justify-center">
            <mat-icon class="icon-size-10 text-gray-400" svgIcon="heroicons_outline:document-magnifying-glass"></mat-icon>
            <p class="mt-2 text-secondary">No se encontraron datos para el resumen</p>
          </div>
        </td>
      </tr>
    </table>

  </div>

  <div class="border-t">
    <mat-paginator
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[50, 100, 200, 500]"
      [disabled]="isLoading$ | async"
      (page)="onPageChange($event)"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>